// extracted by mini-css-extract-plugin
export default {"menuItem":"AttendanceTrans_menuItem__594TK"};